import { render } from "./wordScrollList.vue?vue&type=template&id=5b750afa&scoped=true"
import script from "./wordScrollList.vue?vue&type=script&lang=js"
export * from "./wordScrollList.vue?vue&type=script&lang=js"

import "./wordScrollList.vue?vue&type=style&index=0&id=5b750afa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b750afa"]])

export default __exports__